/**
 * Created by swandelow on 02/02/17.
 */
angular.module('CarsSaraBo').directive('markupNotification', ['$cookies', function ($cookies) {
    return {
        scope: {
            visibility: '=',
            name: '@'
        },

        link: function (scope) {
            const MARKUP_NOTIFICATION_CONFIRMED = scope.name;

            scope.notificationUnderstand = function () {
                scope.visibility = false;
                $cookies.put(MARKUP_NOTIFICATION_CONFIRMED, 'true', {expires: new Date("2117")});
            }
        },
        templateUrl: 'assets/partial/notifications/markup-notification.html'
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/markup_notification_directive.js
// module id = 879
// module chunks = 3